<template>
  <v-navigation-drawer
     v-bind="$attrs"
     v-model="showDrawer"
   >
   </v-navigation-drawer>
</template>
<script>
  export default {
    name: 'MaterialDrawer',
    props: {
      title: {
        type: String,
        default: ''
      },
      drawer: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        showDrawer: this.drawer
      }
    },
    watch: {
      showDrawer (val) {
        this.$emit('on-drawer-change', val)
      },
      drawer (val) {
        this.showDrawer = val
      }
    }
  }
</script>

<style lang="sass" scoped>
  .dialog-toolbat-title
</style>
